import React from 'react';
import { LeftPanelProps } from './LeftPanelProps';

const MainLeftPanel: React.FC<LeftPanelProps> = (data) => {
  return (
    <div className="h-100 w-100 bg-primary py-3 px-3 py-md-6 px-md-5 text-white">
      <h3 className="h4 text-white font-sans-serif mb-2 mb-md-4">
        Why create an account on Lancaster Puppies?
      </h3>
      <ul className="font-awesome-bullets">
        <li className="mb-0 mb-md-3">
          <small>
            <strong>Connect: </strong>
            Millions of buyers and breeders nationwide
          </small>
        </li>
        <li className="mb-0 mb-md-3">
          <small>
            <strong>Discover: </strong>
            Customizable listings to find your ideal dog easily.
          </small>
        </li>
        <li className="mb-0 mb-md-3">
          <small>
            <strong>Chat: </strong>
            Seamless communication with breeders via our messaging system.
          </small>
        </li>
        <li className="mb-0 mb-md-3">
          <small>
            <strong>Trusted breeders: </strong>
            Verified, well-reviewed breeders with accredited badges.
          </small>
        </li>
      </ul>
    </div>
  );
};

export default MainLeftPanel;
